// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2NFMr","title":"ClientInsurance_title__3jaSW","itemText":"ClientInsurance_itemText__1Pamb"};